export { MINUTE } from '@scayle/storefront-nuxt'

export const HOURS = 60
export const SECOND = 1000
export const DAY = 24
